import styled from 'styled-components';

const leftPosition = (props) => {
  const { position } = props;
  const left = position.includes("left");
  const center = position.includes("center");
  if (left)
    return "-8px";
  if (center)
    return "50%";
  return "initial";
};
const topPosition = (props) => {
  const { position } = props;
  const top = position.includes("top");
  const center = !position.includes("bottom") && position.includes("center") || position.includes("right") && !position.includes("-") || position.includes("left") && !position.includes("-");
  if (top)
    return "-8px";
  if (center)
    return "50%";
  return "initial";
};
const centerPosition = (props) => {
  const { position } = props;
  const center = position.includes("center") && !position.includes("-");
  const top = position.includes("top-center") || position.includes("bottom-center");
  const positionX = position.includes("right") && !position.includes("-") || position.includes("left") && !position.includes("-");
  if (center)
    return "translate(-50%, -50%)";
  if (top)
    return "translateX(-50%)";
  if (positionX)
    return "translateY(-50%)";
  return "translate(0)";
};
const BadgeStyled = styled.div`
  position: relative;

  .Badge {
    &__value {
      background-color: var(--palette-primary, #fb5058);
      min-width: 16px;
      height: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      font-size: 8px;
      font-weight: 600;
      padding: 0 6px;
      border-radius: 10px;
      position: absolute;
      top: ${topPosition};
      right: ${(props) => props.position.includes("right") ? "-8px" : "initial"};
      bottom: ${(props) => props.position.includes("bottom") ? "-8px" : "initial"};
      left: ${leftPosition};
      transform: ${centerPosition};
      z-index: 2;
    }
  }
`;

export { BadgeStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
